// Renderiza el adjunto de un comentario de ticket según su tipo.
// Imagen/video/audio se visualizan en línea; cualquier otro tipo (documento)
// se muestra como enlace de descarga. Solo recibe la URL ya subida.
export default function TicketMedia({ url, type, name, muted = '#94a3b8', accent = '#38bdf8' }) {
  if (!url) return null;

  const box = { marginTop: 6, maxWidth: '100%' };
  const media = { maxWidth: '100%', maxHeight: 260, borderRadius: 8, display: 'block' };

  if (type === 'imagen') {
    return (
      <div style={box}>
        <a href={url} target="_blank" rel="noreferrer">
          <img src={url} alt={name || 'imagen'} style={media} />
        </a>
      </div>
    );
  }
  if (type === 'video') {
    return (
      <div style={box}>
        <video src={url} controls style={media} />
      </div>
    );
  }
  if (type === 'audio') {
    return (
      <div style={box}>
        <audio src={url} controls style={{ width: '100%' }} />
      </div>
    );
  }
  // documento u otro: enlace de descarga
  return (
    <div style={box}>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        download={name || true}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6, color: accent,
          fontSize: '0.85rem', textDecoration: 'none', border: `1px solid ${muted}55`,
          borderRadius: 8, padding: '6px 10px', wordBreak: 'break-all',
        }}
      >
        📎 {name || 'Descargar archivo'}
      </a>
    </div>
  );
}
